import config from 'config';

const REQUEST = 'notifications/REQUEST';
const SUCCESS = 'notifications/SUCCESS';
const FAILURE = 'notifications/FAILURE';

const initialState = {
  data: [],
};

export default function info(state = initialState, action = {}) {
  switch (action.type) {
    case SUCCESS:
      return {
        ...state,
        data: action.result,
      };
    case FAILURE:
      return {
        ...state,
        data: [],
      };
    default:
      return state;
  }
}

export function loadNotifications() {
  return {
    types: [REQUEST, SUCCESS, FAILURE],
    promise: async ({ client }) => {
      const { data } = await client.get(`https://${config.apiHost}/v1/notifications`);
      return data;
    },
  };
}
